module.exports = __webpack_public_path__ + "img/messageboard-third-section.af16e088.png";